import {
  SupplierCatalogConfig,
  currency,
  emptyColumn,
  fieldRowsToFields,
  text,
  WithRowId,
} from '../SupplierCatalog/supplierCatalogTypes'
import { DELL_FIELD_ROWS, DellPriceListItem } from './dellTypes'
import { dellItemToLineItem } from './dellLineItemMapping'

export const dellCatalogConfig: SupplierCatalogConfig<WithRowId<DellPriceListItem>> = {
  supplier: 'Dell',
  endpoint: '/dell/catalog',
  rowKey: row => row.rowId,
  partNumber: row => text(row.sku),
  columns: [
    { label: 'Manufacturer', className: 'supplier-catalog-col-manufacturer', render: () => 'Dell' },
    { label: 'Mfr Part #', className: 'supplier-catalog-col-mfr-part', render: row => text(row.sku) },
    {
      label: 'Description',
      className: 'supplier-catalog-col-description',
      render: row => text(row.productDescription),
    },
    { label: 'IMPRES Price', className: 'supplier-catalog-col-impres-price', align: 'right', render: emptyColumn },
    { label: 'MSRP', className: 'supplier-catalog-col-msrp', align: 'right', render: row => currency(row.retailPrice) },
    {
      label: 'Product Category',
      className: 'supplier-catalog-col-product-category',
      render: row => text(row.lobDescription),
    },
    { label: 'Country of Origin', className: 'supplier-catalog-col-country', render: row => text(row.countryOfOrigin) },
    { label: 'TAA', className: 'supplier-catalog-col-taa', render: emptyColumn },
  ],
  drawerFields: fieldRowsToFields(DELL_FIELD_ROWS),
  toLineItem: (lineNumber, row) => dellItemToLineItem(lineNumber, row.sku, row),
}
